import { AuthService } from '../../../common/services/permission/authService.service';
import { Injectable, OnInit } from '@angular/core';
import { Router, Routes } from '@angular/router';
import * as _ from 'lodash';

import { BehaviorSubject } from 'rxjs';

import { HttpClient } from '@angular/common/http';
import { GlobalState } from 'src/app/global.state';

@Injectable()
export class BaMenuService implements OnInit {
  menuItems = new BehaviorSubject<any[]>([]);
  reports: DbReport[] = [];
  protected _currentMenuItem = {};

  constructor(
    private _router: Router,
    private _authService: AuthService,
    private httpClient: HttpClient,
    private state: GlobalState
  ) {}
  private get apiUrl(): string {
    let url = this.state.getGlobalSetting('apiUrl');
    let apiUrl = '';

    if (!!url && url.length > 0) {
      apiUrl = url[0];
    }
    return apiUrl;
  }
  async ngOnInit() {}
  /**
   * Updates the routes in the menu
   *
   * @param {Routes} routes Type compatible with app.menu.ts
   */
  public updateMenuByRoutes(routes: Routes) {
    this.httpClient
      .get(`${this.apiUrl}/v2/getReports`, this._authService.getRequestOption())
      .toPromise()
      .then(
        (ret: any) => {
          this.reports = <DbReport[]>ret.result;
          console.log({
            dbReports: this.reports,
            retResult: ret,
            routes: routes,
          });

          routes
            .filter((x) => x.path == 'pages')[0]
            .children.filter((z) => z.path == 'reports')
            ?.forEach((y) => {
              console.log({ yvalue: y });
              this.reports.forEach((rep) => {
                if (
                  !y.children.find(
                    (x) => x.data.menu.parameter == rep.reportType
                  )
                ) {
                  y.children.push({
                    path: 'QuotationReport',
                    data: {
                      menu: {
                        title: rep.reportName,
                        parameter: rep.reportType,
                      },
                    },
                  });
                }
              });
            });

          console.log({ routesloaded: routes });
          let convertedRoutes = this.convertRoutesToMenus(_.cloneDeep(routes));
          this.menuItems.next(convertedRoutes);
        },
        (error) => {
          let convertedRoutes = this.convertRoutesToMenus(_.cloneDeep(routes));
          this.menuItems.next(convertedRoutes);
          console.log({ errormsg: 'bad request', error: error });
        }
      );
  }

  public convertRoutesToMenus(routes: Routes): any[] {
    let items = this._convertArrayToItems(routes);
    return this._skipEmpty(items);
  }

  public getCurrentItem(): any {
    return this._currentMenuItem;
  }

  public selectMenuItem(menuItems: any[]): any[] {
    let items: any[] = [];
    menuItems.forEach((item) => {
      this._selectItem(item);

      if (item.selected) {
        this._currentMenuItem = item;
      }

      if (item.children && item.children.length > 0) {
        item.children = this.selectMenuItem(item.children);
      }
      let user_profile = this._authService.getUserProfile();
      if (
        user_profile.menuRights.filter(
          (res: any) => res.menu == item.route.path
        ).length != 0
      ) {
        items.push(item);
      }
      //items.push(item);
    });
    return items;
  }

  protected _skipEmpty(items: any[]): any[] {
    let menu: any[] = [];
    items.forEach((item) => {
      let menuItem;
      if (item.skip) {
        if (item.children && item.children.length > 0) {
          menuItem = item.children;
        }
      } else {
        menuItem = item;
      }

      if (menuItem) {
        menu.push(menuItem);
      }
    });

    return [].concat.apply([], menu);
  }

  protected _convertArrayToItems(routes: any[], parent?: any): any[] {
    let items: any[] = [];
    routes.forEach((route) => {
      items.push(this._convertObjectToItem(route, parent));
    });
    return items;
  }

  protected _convertObjectToItem(object: any, parent?: any): any {
    let item: any = {};
    if (object.data && object.data.menu) {
      // this is a menu object
      item = object.data.menu;
      item.route = object;
      delete item.route.data.menu;
    } else {
      item.route = object;
      item.skip = true;
    }

    // we have to collect all paths to correctly build the url then
    if (Array.isArray(item.route.path)) {
      item.route.paths = item.route.path;
    } else {
      item.route.paths =
        parent && parent.route && parent.route.paths
          ? parent.route.paths.slice(0)
          : ['/'];
      if (!!item.route.path) item.route.paths.push(item.route.path);
    }

    if (object.children && object.children.length > 0) {
      item.children = this._convertArrayToItems(object.children, item);
    }
    if (item.parameter) {
      item.route.paths.push({ reportname: item.parameter });
    }
    let prepared = this._prepareItem(item);

    // if current item is selected or expanded - then parent is expanded too
    if ((prepared.selected || prepared.expanded) && parent) {
      parent.expanded = true;
    }

    return prepared;
  }

  protected _prepareItem(object: any): any {
    if (!object.skip) {
      object.target = object.target || '';
      object.pathMatch = object.pathMatch || 'full';
      return this._selectItem(object);
    }

    return object;
  }

  protected _selectItem(object: any): any {
    var queryparam = object.route.parameter
      ? { queryParam: { reportname: object.route.parameter } }
      : '';

    object.selected = this._router.isActive(
      this._router.createUrlTree(object.route.paths),
      {
        paths: 'exact',
        queryParams: 'exact',
        fragment: 'ignored',
        matrixParams: 'exact',
      }
    );

    //console.log({ menuSelected: object });
    return object;
  }
}

export class DbReport {
  reportName: string = '';
  reportType: string = '';
}
